// Простой class-merger в стиле clsx — для shadcn-подобных компонентов.
// Без tailwind-merge: если потребуется override классов, передавай нужный
// класс последним. Хватает для всех текущих случаев.
export function cn(...args) {
    return args.filter(Boolean).join(" ");
}
